import { useRef } from 'react';

import { ISearchResult, SearchResultCategory } from '~/lib/data-contract';
import { useFrame } from '~/shared/utils/frame/hooks/useFrame';
import { useMarket } from '~/shared/utils/market/hooks/useMarket';
import { useGetRequest } from '~/shared/utils/request/hooks/useGetRequest';

type UseSearchResultsOpts = {
	query?: string;
	pageSize?: number;
	category?: SearchResultCategory;
	minQueryLength?: number;
	keepPreviousData?: boolean;
	onSuccess?: (data: ISearchResult) => void;
};

export const useSearchResults = ({ query = '', pageSize, category, minQueryLength = 3, keepPreviousData = true, onSuccess }: UseSearchResultsOpts) => {
	const { data: frame } = useFrame();
	const market = useMarket();
	const initialSearch = useRef(false);

	return useGetRequest<ISearchResult>('/api/proxy/search/results', {
		params: {
			frameId: frame.id,
			...market,
			query,
			...(pageSize ? { pageSize } : undefined),
			...(category ? { category } : undefined),
		},
		enabled: !initialSearch || query?.length >= minQueryLength,
		keepPreviousData: keepPreviousData && query?.length >= minQueryLength,
		onSuccess: (data) => {
			if (!initialSearch.current) {
				initialSearch.current = true;
			}
			onSuccess?.(data);
		},
	});
};
